import { render, staticRenderFns } from "./JustificatifBeneficiaire.vue?vue&type=template&id=e50d6aa4"
import script from "./JustificatifBeneficiaire.vue?vue&type=script&lang=js"
export * from "./JustificatifBeneficiaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports